import { render, staticRenderFns } from "./ExpCompanyPageAdd.vue?vue&type=template&id=0021cc1c&scoped=true&"
import script from "./ExpCompanyPageAdd.vue?vue&type=script&lang=js&"
export * from "./ExpCompanyPageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021cc1c",
  null
  
)

export default component.exports